import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, BookOpen, Music } from 'lucide-react';
import { heroData } from '../data/mock';

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.pexels.com/photos/237836/pexels-photo-237836.jpeg)',
            filter: 'brightness(0.3)'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gunmetal-950/80 via-gunmetal-900/90 to-gunmetal-950"></div>
        
        {/* Animated grain texture overlay */}
        <div className="absolute inset-0 opacity-30 noise-texture"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="space-y-8 animate-fade-in-up">
          {/* Subtitle */}
          <div className="inline-block">
            <p className="text-accent-red font-bold tracking-widest uppercase text-sm md:text-base mb-4 animate-pulse-subtle">
              {heroData.subtitle}
            </p>
          </div>

          {/* Main Title */}
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black leading-tight tracking-tight">
            <span className="block mb-2 text-platinum animate-chrome-pulse">{heroData.tagline}</span>
          </h1>

          {/* Core Campaign Slogan */}
          <div className="my-8 py-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
              <div className="group">
                <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-diamond mb-2">
                  LIVE
                </h3>
                <p className="text-xl md:text-2xl font-bold text-accent-red">MORE</p>
              </div>
              <div className="group">
                <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-diamond mb-2">
                  LOVE
                </h3>
                <p className="text-xl md:text-2xl font-bold text-accent-red">MORE</p>
              </div>
              <div className="group">
                <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-diamond mb-2">
                  LAUGH
                </h3>
                <p className="text-xl md:text-2xl font-bold text-accent-red">MORE</p>
              </div>
              <div className="group">
                <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-diamond mb-2">
                  GIVE
                </h3>
                <p className="text-xl md:text-2xl font-bold text-accent-red">MORE</p>
              </div>
            </div>
            <div className="mt-6">
              <p className="text-lg md:text-xl text-steel-300 italic">
                The Core Foundation of MINDESIGN ENTERPRISES
              </p>
            </div>
          </div>

          {/* Tagline */}
          <div className="max-w-3xl mx-auto">
            <p className="text-3xl sm:text-4xl md:text-5xl font-bold text-metallic-ice mb-6 tracking-wide">
              {heroData.description}
            </p>
            <p className="text-lg md:text-xl text-steel-400 max-w-2xl mx-auto leading-relaxed">
              A transmedia powerhouse with 200+ songs, 30+ original stories, and 30 years of creative mastery 
              bridging art and inspiration through the MINDESIGN ENTERPRISES VAULT.
            </p>
          </div>

          {/* Founder Credit */}
          <p className="text-steel-500 text-sm md:text-base tracking-wider">
            Founded by <span className="text-accent-red font-semibold">{heroData.founderName}</span>
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Button 
              className="bg-accent-red hover:bg-accent-red-dark text-white font-bold px-8 py-6 text-lg transition-all duration-300 hover:shadow-2xl hover:shadow-accent-red/40 hover:scale-105 group"
              onClick={() => window.location.hash = '#books'}
            >
              <BookOpen className="mr-2 group-hover:rotate-12 transition-transform duration-300" size={24} />
              Explore Literary Works
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" size={20} />
            </Button>
            <Button 
              variant="outline"
              className="border-2 border-steel-400 text-steel-200 hover:bg-steel-400 hover:text-gunmetal-900 font-bold px-8 py-6 text-lg transition-all duration-300 hover:shadow-xl group"
              onClick={() => window.location.hash = '#music'}
            >
              <Music className="mr-2 group-hover:scale-110 transition-transform duration-300" size={24} />
              Listen to Soundscapes
            </Button>
          </div>

          {/* Scroll Indicator */}
          <div className="pt-16 animate-bounce-slow">
            <div className="flex flex-col items-center text-steel-500">
              <span className="text-xs uppercase tracking-widest mb-2">Scroll to Explore</span>
              <div className="w-6 h-10 border-2 border-steel-500 rounded-full flex items-start justify-center p-2">
                <div className="w-1.5 h-3 bg-accent-red rounded-full animate-scroll-indicator"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
